/**
 * Convert a string to a URL-friendly slug
 * @param {string} text - The text to convert to slug
 * @returns {string} - The URL-friendly slug
 */
export const slugify = (text) => {
  return text
    .toString()
    .toLowerCase()
    .trim()
    // Replace spaces with hyphens
    .replace(/\s+/g, '-')
    // Remove all non-word chars except hyphens
    .replace(/[^\w-]+/g, '')
    // Replace multiple hyphens with single hyphen
    .replace(/-+/g, '-')
    // Remove leading/trailing hyphens
    .replace(/^-+/, '')
    .replace(/-+$/, '');
};

/**
 * Find a project by its slug
 * @param {Array} projects - Array of project objects
 * @param {string} slug - The slug to search for
 * @returns {Object|null} - The found project or null
 */
export const findProjectBySlug = (projects, slug) => {
  return projects.find(project => project.slug === slug) || null;
};

/**
 * Generate a project URL using slug
 * @param {string} slug - The project slug
 * @returns {string} - The project URL
 */
export const getProjectUrl = (slug) => {
  return `/projects/${slug}`;
};
